export default {
  '--pagination-list-bg-color': '#303030',
  '--pagination-hover-bg-color': '#25293a',
  '--pagination-list-active-bg-color': '#25293a',
  '--pagination-list-active-color': '#4a7afe',
  '--pagination-item-background': '#303030'
};